import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

// Lista de termos (GET /terms) e geração de termo no quarkus.
export function usePatientTerms() {
  const navigate = useNavigate();

  const [terms, setTerms] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTerms = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/terms', authHeader())
      .then((returnFromApi) => setTerms(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const generateTerm = useCallback(
    (patientId, termTemplateId, dentistId) =>
      quarkusApi.get(
        `/patients/${patientId}/terms/${termTemplateId}/generate?dentistId=${dentistId}`,
        {
          ...authHeader(),
          responseType: 'blob',
        },
      ),
    [],
  );

  useEffect(() => {
    fetchTerms();
  }, [fetchTerms]);

  return { terms, isLoading, error, refetch: fetchTerms, generateTerm };
}
